// THE single shared appeal-pack price constant — the source of truth consumed
// by the server (appeal creation), the app (via the `band-check.pricing` /
// appeal tRPC query, so the app never hardcodes it), the marketing copy, and
// the Stripe smoke. Change the price here and it flows everywhere; the next
// change is one line.
//
// The Prisma `PricingVariant` enum (FLAT_19 / FLAT_29 / FLAT_39 / FLAT_12 /
// FLAT_499) is kept so historical Appeal rows from earlier price points still
// carry the variant they were quoted at — but every new Appeal is the current
// variant. FLAT_499 is the £4.99 cohort (the value is in pence, since this is
// the first sub-£1-granularity price point).
export const PRICE_PENCE = 499
// Display string for copy. Derived so a price change stays one line — drops the
// pence for whole-pound prices (→ "£12") and keeps them otherwise (→ "£4.99").
export const PRICE_GBP = `£${(PRICE_PENCE / 100).toFixed(PRICE_PENCE % 100 === 0 ? 0 : 2)}`
export const PRICING_VARIANT = 'FLAT_499' as const

// Optional tribunal-prep upgrade (sold separately from the appeal pack). Set
// explicitly on TribunalPack creation from here — the schema's column default is
// kept in sync but is no longer the source of truth.
export const TRIBUNAL_PRICE_PENCE = 1_900
export const TRIBUNAL_PRICE_GBP = `£${TRIBUNAL_PRICE_PENCE / 100}` // "£19"
